import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import {
  SessionLogSource,
  SessionLogsResponse
} from '@utils/types/back-office/session-inspector';

export const SESSION_INSPECTOR_LOGS_KEY = 'session-inspector-logs';

export const useGetSessionLogs = (
  zoomId: string | null,
  source: SessionLogSource,
  enabled: boolean,
  limit = 500
) => {
  const fetchLogs = async (): Promise<SessionLogsResponse> => {
    const params = new URLSearchParams();
    params.set('source', source);
    params.set('limit', String(limit));
    const { data } = await Axios.get<SessionLogsResponse>(
      `/api/admin/session-inspector/${zoomId}/logs?${params}`
    );
    return data;
  };

  return useQuery<SessionLogsResponse>(
    [SESSION_INSPECTOR_LOGS_KEY, zoomId, source, limit],
    fetchLogs,
    {
      enabled: enabled && Boolean(zoomId),
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: false
    }
  );
};
